import { t } from "i18next";
import { enqueueSnackbar } from "notistack";

import { apiClient } from "../../ApiClient";
import { KsefIntegrationInvalidationReason } from "../../ServerEndpoints";
import { config } from "../../config";
import { GetState, SetState, Store, StoreData } from "../types";

let pollingInterval: number | undefined = undefined;

export const startPolling = (set: SetState<StoreData>, get: GetState<Store>) => () => {
  if (pollingInterval !== undefined) {
    console.warn(`Polling already working (ID: ${pollingInterval}), skipping`);
    return;
  }
  const pollingFn = async (step = 0) => {
    const integrationId = get().integrationId!;

    if (integrationId === undefined) {
      console.warn("Integration ID is undefined");
      return;
    }

    try {
      const response = await apiClient.integrations.getIntegrationsId(integrationId);

      const integration = response.data;

      if (integration.state !== "TokenProvided" && integration.state !== "SessionSignedRequestProvided") {
        set((s: StoreData) => ({
          ...s,
          integration,
        }));
      } else {
        const delay =
          config.statusPollingInterval[step] ??
          config.statusPollingInterval[config.statusPollingInterval.length - 1] ??
          5;
        console.debug(`Next polling call in ${delay} seconds`);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        pollingInterval = setTimeout(() => pollingFn(step + 1), delay * 1000);
      }
    } catch (error: any) {
      const textLocKey = getKsefInvalidationReasonTexts(error?.response?.invalidationReason);
      enqueueSnackbar({ message: t(textLocKey), variant: "error" });
    }
  };

  console.debug("Start polling");
  pollingFn();
};

export const stopPolling = () => () => {
  if (pollingInterval !== undefined) {
    console.debug("Stop polling");
    clearTimeout(pollingInterval);
  }
};

export const getKsefInvalidationReasonTexts = (invalidationReason?: KsefIntegrationInvalidationReason) => {
  const kind = invalidationReason?.kind;

  if (!kind) {
    return "error.title";
  }

  if (kind === "UnknownError") {
    return invalidationReason.message || "error.UnknownError.description";
  }

  return `error.${kind}.description`;
};
